module.exports =  {
                    CODE_DISABLED: 'CODE_DISABLED',
                    CODE_ENABLED: 'CODE_ENABLED',
                    CODE_SELECTED: 'CODE_SELECTED',
                    CODE_DRAGGING: 'CODE_DRAGGING',
                    CODE_MERGING_ENABLED: 'CODE_MERGING_ENABLED',
                    CODE_MERGING_DISABLED: 'CODE_MERGING_DISABLED',
                    CODE_GHOSTED: 'CODE_GHOSTED'
                  }
